<template>
  <v-dialog :value="isActive" @click:outside="closeDialog()" max-width="600" scrollable>
    <ValidationObserver ref="formObs" v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ isEditMode ? "Actualizar" : "Crear" }} plantilla
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text :style="`max-height: ${DIALOG_MAX_HEIGHT}`">
            <v-form class="mt-4">
              <v-row dense>
                <!-- Título -->
                <v-col cols="12">
                  <ValidationProvider name="Título" rules="required" v-slot="{ errors }">
                    <v-text-field
                      v-model="payload.title"
                      :error-messages="errors"
                      label="Título de la plantilla"
                      rounded
                      dense
                      class="rounded-small"
                      filled
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <!-- Identificador (Name) -->
                <v-col cols="12" sm="6">
                  <ValidationProvider name="Nombre identificador" rules="required" v-slot="{ errors }">
                    <v-text-field
                      v-model="payload.name"
                      :error-messages="errors"
                      label="Nombre identificador Meta"
                      persistent-hint
                      rounded
                      dense
                      class="rounded-small"
                      filled
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <!-- Tipo -->
                <v-col cols="12" sm="6">
                  <ValidationProvider name="Tipo" rules="required" v-slot="{ errors }">
                    <v-select
                      v-model="payload.type"
                      :items="typeOptions"
                      :error-messages="errors"
                      label="Tipo de mensaje"
                      rounded
                      dense
                      class="rounded-small"
                      filled
                    ></v-select>
                  </ValidationProvider>
                </v-col>

                <!-- Configuración WhatsApp ID -->
                <v-col cols="12" sm="6">
                  <ValidationProvider name="Configuración WhatsApp" rules="required" v-slot="{ errors }">
                    <v-select
                      v-model="payload.whatsapp_id"
                      :items="whatsappList"
                      :loading="isLoadingConfigs"
                      item-text="name"
                      item-value="id"
                      :error-messages="errors"
                      label="Cuenta de WhatsApp"
                      rounded
                      dense
                      class="rounded-small"
                      filled
                    ></v-select>
                  </ValidationProvider>
                </v-col>

                <!-- Número de parámetros -->
                <v-col cols="12" sm="6">
                  <ValidationProvider name="Número de parámetros" rules="required|numeric" v-slot="{ errors }">
                    <v-text-field
                      v-model.number="payload.parameter_number"
                      :error-messages="errors"
                      label="N° de Parámetros"
                      type="number"
                      rounded
                      dense
                      class="rounded-small"
                      filled
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <!-- Parámetros (Combobox múltiple) -->
                <v-col cols="12">
                  <ValidationProvider name="Parámetros" rules="required" v-slot="{ errors }">
                    <v-combobox
                      v-model="payload.parameter"
                      :items="parameterSuggestions"
                      label="Nombres de Parámetros"
                      persistent-hint
                      multiple
                      chips
                      deletable-chips
                      rounded
                      dense
                      filled
                      class="rounded-small"
                      :error-messages="errors"
                    ></v-combobox>
                  </ValidationProvider>
                </v-col>

                <!-- Mensaje -->
                <v-col cols="12">
                  <ValidationProvider name="Mensaje" rules="required" v-slot="{ errors }">
                    <v-textarea
                      v-model="payload.message"
                      :error-messages="errors"
                      label="Mensaje del cuerpo"
                      persistent-hint
                      rows="3"
                      rounded
                      dense
                      class="rounded-small"
                      filled
                    ></v-textarea>
                  </ValidationProvider>
                </v-col>

                <!-- Adjunta Archivo / Imagen -->
                <v-col cols="12" sm="6" class="d-flex align-center">
                  <v-switch
                    v-model="payload.file"
                    label="¿Contiene archivo / imagen?"
                    color="success"
                    inset
                    dense
                  ></v-switch>
                </v-col>

                <!-- Es Global -->
                <v-col cols="12" sm="6" class="d-flex align-center">
                  <v-switch
                    v-model="payload.is_global"
                    label="¿Es Plantilla Global?"
                    color="primary"
                    inset
                    dense
                  ></v-switch>
                </v-col>

                <!-- URL de Imagen (Solo si file es true) -->
                <v-col cols="12" v-if="payload.file">
                  <ValidationProvider name="URL de Imagen" rules="required" v-slot="{ errors }">
                    <v-text-field
                      v-model="payload.image_url"
                      :error-messages="errors"
                      label="URL de la imagen"
                      placeholder="https://dominio.com/imagen.png"
                      rounded
                      dense
                      class="rounded-small"
                      filled
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <v-card-actions class="pa-4">
          <v-btn @click="closeDialog()" class="px-8" color="error" rounded large text>
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn @click="handleSubmit(submitForm)" :disabled="isLoading" class="px-8" color="success" rounded large>
            {{ isEditMode ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import { DIALOG_MAX_HEIGHT } from "@/utils";

export default {
  components: {
    vuescroll,
  },

  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    dataToEdit: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      DIALOG_MAX_HEIGHT,
      isLoading: false,
      isLoadingConfigs: false,
      whatsappList: [],
      typeOptions: ["notification", "marketing", "utility", "authentication"],
      parameterSuggestions: [
        "nombre_cliente",
        "codigo_verificacion",
        // "specialty",
        // "date",
        // "time",
        // "responsible",
        // "direction",
      ],
      payload: {
        title: "",
        name: "",
        type: "notification",
        whatsapp_id: null,
        parameter_number: 0,
        parameter: [],
        message: "",
        is_global: false,
        file: false,
        image_url: "",
      },
    };
  },

  watch: {
    isActive(val) {
      if (val) {
        this.getWhatsappConfigs();
        this.initPayload();
      }
    },
  },

  created() {
    if (this.isActive) {
      this.getWhatsappConfigs();
      this.initPayload();
    }
  },

  methods: {
    initPayload() {
      if (this.isEditMode && this.dataToEdit) {
        this.payload = {
          title: this.dataToEdit.title || "",
          name: this.dataToEdit.name || "",
          type: this.dataToEdit.type || "notification",
          whatsapp_id: this.dataToEdit.whatsapp_id || null,
          parameter_number: this.dataToEdit.parameter_number || 0,
          parameter: Array.isArray(this.dataToEdit.parameter) ? [...this.dataToEdit.parameter] : [],
          message: this.dataToEdit.message || "",
          is_global: !!this.dataToEdit.is_global,
          file: !!this.dataToEdit.file,
          image_url: this.dataToEdit.image_url || "",
          id: this.dataToEdit.id,
        };
      } else {
        this.resetForm();
      }
    },

    resetForm() {
      this.payload = {
        title: "",
        name: "",
        type: "notification",
        whatsapp_id: null,
        parameter_number: 0,
        parameter: [],
        message: "",
        is_global: false,
        file: false,
        image_url: "",
      };
      if (this.$refs.formObs) {
        this.$refs.formObs.reset();
      }
    },

    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },

    async getWhatsappConfigs() {
      this.isLoadingConfigs = true;
      try {
        const { data } = await PbxHttpClient.get("/whatsapps/config/index_select");
        this.whatsappList = data || [];
      } catch (err) {
        this.$snotify.error("No se pudo obtener el listado de WhatsApp.", "Error");
      } finally {
        this.isLoadingConfigs = false;
      }
    },

    async submitForm() {
      this.isLoading = true;

      try {
        const { id, ...bodyPayload } = this.payload;

        // Limpiar la imagen si file es falso
        if (!bodyPayload.file) {
          bodyPayload.image_url = "";
        }

        // POST: /templates-Meta
        // PUT: /templates-Meta/{id}
        const { data } = this.isEditMode
          ? await PbxHttpClient.put(`/templates-Meta/${id}`, bodyPayload)
          : await PbxHttpClient.post("/templates-Meta", bodyPayload);

        this.$snotify.success(`Plantilla ${this.isEditMode ? "actualizada" : "creada"} con éxito.`, "¡Hecho!");
        this.closeDialog(data || bodyPayload);
      } catch (err) {
        this.$snotify.error("No se pudo guardar la plantilla.", "¡Error!");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
